module.exports = "{{#list}}\n  <li data-id=\"{{id}}\" {{#selected}}class=\"selected\"{{/selected}}>{{label}}</li>\n{{/list}}"